let _id = 0;

/**
 * Null or undefined check on value
 * @param {any} value - can be of any type
 * @return {Boolean} - result of value is null or undefined
 * */
export const isNull = value => {
  return value === null || value === undefined;
};

/**
 * Http request payload structure for native apis.
 *
 * @param {object} data - input data to be pass on the body of ajax call.
 * @returns {object} - json object as par structure of native apis.
 */
export const requestPayload = data => {
  return {
    head: {
      version: 'v1',
      requestTimestamp: Date.now(),
      channelId: 'WEB',
      token: '',
      tokenType: '',
      workFlow: 'checkout'
    },
    body: data
  };
};

export const requestIFSCPayload = data => {
  return {
    operationType: 'P2B_TRANSFER',
    channel: 'MP-ANDROID',
    ipAddress: '127.0.0.1',
    request: data,
    version: '8.8.0',
    platformName: 'PayTM'
  };
};

export const appendQueryInUrl = (url, query) => {
  let output = `${url}?`;
  Object.keys(query).forEach(key => {
    if (Object.prototype.hasOwnProperty.call(query, key)) {
      output += `${key}=${query[key]}&`;
    }
  });
  return output;
};

/**
 * Generate an Theia API endpoint based on configuration environment
 *
 * @param {string} path - _API service url apart from host server.
 * @returns {string} - API endpoint including host server
 */

export const apiEndpoint = path => {
  let url = '';
  if (API_HOST) {
    url = API_HOST;
  }
  if (path) {
    url += path;
  }
  return url;
};

export const walletApiEndPoint = path => {
  let url = '';
  if (WALLET_API_HOST) {
    url = WALLET_API_HOST;
  }
  if (path) {
    url += path;
  }
  return url;
};

/**
 * Generate an Merchant API endpoint based on configuration environment
 *
 * @param {string} path - _API service url apart from host server.
 * @returns {string} - API endpoint including host server
 */

export const merchantServerEndpoint = path => {
  let url = '';
  if (MERCHANT_HOST) {
    url = MERCHANT_HOST;
  }
  if (path) {
    url += path;
  }
  return url;
};

export const getStaticPath = () => {
  let _url = STATIC_HOST;

  try {
    if (typeof window !== 'undefined') {
      if (VERSION) {
        _url += `/${APP_NAME}/${VERSION}`;
      }
    }
  } catch (e) {}
  return _url;
};

/**
 * Check if key exists in object or not
 * @param {Object} obj - object
 * @param {String} key - field name to be check in object
 * @return {Boolean} - return true if key exists in object otherwise false
 * */
export const has = (obj, key) => {
  return Object.prototype.hasOwnProperty.call(obj, key);
};

export const iFrameApiCall = payload => {
  return new Promise((resolve, reject) => {
    if (ENV === 'test') {
      // resolve();
      // payload.skipMiddleware = true;
      // _ajax(payload)
      //   .then(data => {
      //     resolve(data);
      //   })
      //   .catch(err => {
      //     reject(err);
      //   });
    } else {
      const dummyFrame = document.getElementById('dummy-iframe');
      if (dummyFrame) {
        const handler = (id, event) => {
          switch (event.data.id === id && event.data.type) {
            case 'successApiCallResponse':
              resolve(event.data.responses[0]);
              window.removeEventListener('message', handler);
              break;
            case 'errorApiCallResponse':
              reject(event.data.response);
              window.removeEventListener('message', handler);
              break;
            default:
              break;
          }
        };
        window.addEventListener('message', handler.bind(null, _id));
        dummyFrame.contentWindow.postMessage(
          { type: 'MAKECALL', requests: [payload], id: _id },
          '*'
        );
        _id += 1;
      }
    }
  });
};

/**
 * Validate whether an input is an Object or not.
 *
 * @export
 * @param {*} input
 * @returns {boolean} is input is an Object?
 */
export function isObject(input) {
  return Object.prototype.toString.call(input) === '[object Object]';
}

/**
 * Gets object values
 *
 * @export
 * @param {Object} input
 * @returns {Array<*>} Array pf object values
 */
export function objectValues(input) {
  if (isObject(input)) {
    return Object.keys(input).reduce((acc, key) => {
      acc.push(input[key]);
      return acc;
    }, []);
  }

  return [];
}

/**
 * Get property value from nested object
 *
 * @param {Object} obj - object to perform property lookup
 * @param {String} path - the path at which lookup is performed
 * @param {*} defaultValue (optional) -  default value to be reurned if property not found
 * @returns {*} - returns the property value if found else returns dafaultValue
 */
export const getKey = (obj, path, defaultValue) => {
  const result = String.prototype.split
    .call(path, /[,[\].]+?/)
    .filter(Boolean)
    .reduce((res, key) => (!isNull(res) ? res[key] : res), obj);
  return isNull(result) || result === obj ? defaultValue : result;
};

/**
 * Validate whether an input is function or not.
 *
 * @export
 * @param {*} input
 * @returns {boolean} is input is function?
 */
export function isFunction(input) {
  return typeof input === 'function';
}

export const isWebViewDetected = () => {
  const userAgent = window.navigator && window.navigator.userAgent;
  /* Check for Safari Web View */
  const isSafariWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(userAgent);
  if (
    isSafariWebView ||
    /wv/i.test(userAgent) ||
    (!/UCBrowser/g.test(userAgent) &&
      (/version\/[0-9].[0-9]/i.test(userAgent) && /Chrome\/\d*.\d*.\d*.\d*/i.test(userAgent)))
  ) {
    return true;
  }
  return false;
};

export const isWebViewFlow = mConfig => {
  return (
    isWebViewDetected() && !(mConfig && mConfig.merchant && mConfig.merchant.multipleWindowWebview)
  );
};



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Preprod-BnR/Deploy_checkoutjs/common/src/utils/common.js